import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";
import commonEN from "./translations/en/common.json";
import formEN from "./translations/en/form.json";
import validationEN from "./translations/en/validation.json";
import commonNL from "./translations/nl/common.json";
import formNL from "./translations/nl/form.json";
import validationNL from "./translations/nl/validation.json";
import commonDE from "./translations/de/common.json";
import formDE from "./translations/de/form.json";
import validationDE from "./translations/de/validation.json";
import commonIT from "./translations/it/common.json";
import formIT from "./translations/it/form.json";
import validationIT from "./translations/it/validation.json";
import commonFR from "./translations/fr/common.json";
import formFR from "./translations/fr/form.json";
import validationFR from "./translations/fr/validation.json";
const resources = {
    en: {
        common: commonEN,
        form: formEN,
        validation: validationEN,
    },
    nl: {
        common: commonNL,
        form: formNL,
        validation: validationNL,
    },
    de: {
        // The German JSON files include their namespace as a top-level wrapper.
        common: commonDE.common,
        form: formDE.form,
        validation: validationDE.validation,
    },
    it: {
        common: commonIT,
        form: formIT,
        validation: validationIT,
    },
    fr: {
        common: commonFR,
        form: formFR,
        validation: validationFR,
    },
};
const savedLanguage = localStorage.getItem("i18nextLng") || "nl";
i18n
    .use(XHR)
    .use(LngDetector)
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: "en",
    lng: savedLanguage,
    detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
    },
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
